import { z } from 'zod';

export const GEMINI_VOICES = [
  { id: 'Zephyr', gender: 'female', style: 'Bright', description: '明亮有穿透力，适合开场和轻快段落' },
  { id: 'Puck', gender: 'male', style: 'Upbeat', description: '轻快积极，适合年轻角色和行动段落' },
  { id: 'Charon', gender: 'male', style: 'Informative', description: '清楚稳健，适合说明和理性角色' },
  { id: 'Kore', gender: 'female', style: 'Firm', description: '坚定沉稳，适合旁白和主角' },
  { id: 'Fenrir', gender: 'male', style: 'Excitable', description: '情绪鲜明，适合紧张和激烈反应' },
  { id: 'Leda', gender: 'female', style: 'Youthful', description: '年轻自然，适合少年和年轻配角' },
  { id: 'Orus', gender: 'male', style: 'Firm', description: '硬朗克制，适合执行者和对立角色' },
  { id: 'Aoede', gender: 'female', style: 'Breezy', description: '轻盈松弛，适合日常对白' },
  { id: 'Callirrhoe', gender: 'female', style: 'Easy-going', description: '随和自然，适合朋友和生活化角色' },
  { id: 'Autonoe', gender: 'female', style: 'Bright', description: '清亮明快，适合积极角色' },
  { id: 'Enceladus', gender: 'male', style: 'Breathy', description: '带气声，适合低语和脆弱情绪' },
  { id: 'Iapetus', gender: 'male', style: 'Clear', description: '发音清晰，适合信息密集的段落' },
  { id: 'Umbriel', gender: 'male', style: 'Easy-going', description: '松弛平和，适合温和配角' },
  { id: 'Algieba', gender: 'male', style: 'Smooth', description: '顺滑从容，适合成熟角色' },
  { id: 'Despina', gender: 'female', style: 'Smooth', description: '柔和流畅，适合情感叙事' },
  { id: 'Erinome', gender: 'female', style: 'Clear', description: '清楚利落，适合调查和对话' },
  { id: 'Algenib', gender: 'male', style: 'Gravelly', description: '沙哑低沉，适合疲惫或神秘角色' },
  { id: 'Rasalgethi', gender: 'male', style: 'Informative', description: '理性清楚，适合专业人物' },
  { id: 'Laomedeia', gender: 'female', style: 'Upbeat', description: '有活力，适合外向角色' },
  { id: 'Achernar', gender: 'female', style: 'Soft', description: '柔软安静，适合温柔段落' },
  { id: 'Alnilam', gender: 'male', style: 'Firm', description: '稳重有力，适合领导者' },
  { id: 'Schedar', gender: 'male', style: 'Even', description: '平稳均衡，适合长期旁白' },
  { id: 'Gacrux', gender: 'female', style: 'Mature', description: '成熟厚重，适合年长人物' },
  { id: 'Pulcherrima', gender: 'female', style: 'Forward', description: '主动直接，适合强势角色' },
  { id: 'Achird', gender: 'male', style: 'Friendly', description: '亲和自然，适合年轻主角' },
  { id: 'Zubenelgenubi', gender: 'male', style: 'Casual', description: '随意口语化，适合朋友对白' },
  { id: 'Vindemiatrix', gender: 'female', style: 'Gentle', description: '温和克制，适合安静人物' },
  { id: 'Sadachbia', gender: 'male', style: 'Lively', description: '灵动活泼，适合轻松配角' },
  { id: 'Sadaltager', gender: 'male', style: 'Knowledgeable', description: '睿智可靠，适合导师和讲述者' },
  { id: 'Sulafat', gender: 'female', style: 'Warm', description: '温暖柔和，适合情绪收束' },
] as const;

export type GeminiVoiceId = (typeof GEMINI_VOICES)[number]['id'];
export const GEMINI_VOICE_IDS = GEMINI_VOICES.map((voice) => voice.id) as [GeminiVoiceId, ...GeminiVoiceId[]];
export const geminiVoiceIdSchema = z.enum(GEMINI_VOICE_IDS);

export function isGeminiVoice(value: string): value is GeminiVoiceId {
  return GEMINI_VOICES.some((voice) => voice.id === value);
}

export function getGeminiVoice(voice: string) {
  return GEMINI_VOICES.find((option) => option.id === voice);
}

export function voiceGenderLabel(voice: string) {
  return getGeminiVoice(voice)?.gender === 'female' ? '女声' : '男声';
}

export const projectAudioConfigSchema = z.object({
  narrator: geminiVoiceIdSchema,
  characters: z.record(geminiVoiceIdSchema),
}).strict();

export type ProjectAudioConfig = z.infer<typeof projectAudioConfigSchema>;

export const DEFAULT_PROJECT_AUDIO_CONFIG: ProjectAudioConfig = {
  narrator: 'Kore',
  characters: {},
};
